import {Injectable} from '@angular/core';
import {CrudService} from "@shared/api/services/crud.service";
import {PatientRecordRisk} from "@shared/api/models/query/patient-record-risk.model";
import {PatientRecordRiskUpdate} from "@shared/api/models/command/patient-record-risk.model";

@Injectable({
    providedIn: 'root'
})
export class PatientRecordRisksService extends CrudService<
    PatientRecordRisk,
    PatientRecordRisk,
    PatientRecordRiskUpdate,
    PatientRecordRiskUpdate
> {

    protected override get domainEntity() {
        return 'patients'
    };

    protected override get subdomainEntity() {
        return 'record-risks';
    };
}
